export const settings: any = {
  pageSize: 25
};
